import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Programs',
    path: '/programs'
  }, {
    name: 'Schedule',
    path: '/schedule'
  }, {
    name: 'Staff',
    path: '/staff'
  }, {
    name: 'Gallery',
    path: '/gallery'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4'}`} data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="flex justify-between items-center" data-id="element-212">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-id="element-213">
            <img src="https://cdn.magicpatterns.com/uploads/bCnrHjDC6m1HYFyzaNTkeb/3.5x1.3_Limitless_Chest_Print.png" alt="Limitless Taekwondo Logo" className="h-10 w-auto transition-transform group-hover:scale-105" data-id="element-214" />
            <span className="text-xl md:text-2xl font-bold text-primary tracking-tight" data-id="element-215">
              Limitless Taekwondo
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-216">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${location.pathname === link.path ? 'text-primary' : 'text-gray-600'}`} data-id="element-217">
                {link.name}
              </Link>)}
            <Link to="/trial" data-id="element-218">
              <Button variant="primary" size="sm" data-id="element-219">
                4-Week Trial
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden" data-id="element-220">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-primary focus:outline-none" aria-label="Toggle menu" data-id="element-221">
              {isOpen ? <X className="h-6 w-6" data-id="element-222" /> : <Menu className="h-6 w-6" data-id="element-223" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-224">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-225">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-226">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === link.path ? 'bg-blue-50 text-primary' : 'text-gray-600 hover:bg-gray-50 hover:text-primary'}`} data-id="element-227">
                  {link.name}
                </Link>)}
              <div className="pt-4" data-id="element-228">
                <Link to="/trial" className="block w-full" data-id="element-229">
                  <Button variant="primary" fullWidth data-id="element-230">
                    Get 4-Week Trial
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}